import type { GenericAttachment } from '@/styles/GenericAttachmentsSection';
import { uploadEntityAttachments, fetchEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';

// Checklist attachments: the shared implementation (lib/entity-attachments.ts)
// -- this file only names the entity type these files belong to.
const ENTITY_TYPE = 'checklist';

export type ChecklistFileAttachment = GenericAttachment;

export function uploadChecklistAttachments(parentId: string | undefined, files: File[], companyId: string, userId: string): Promise<ChecklistFileAttachment[]> {
  return uploadEntityAttachments(ENTITY_TYPE, parentId, files, companyId, userId);
}

export function fetchChecklistAttachments(parentId: string, opts?: { ascending?: boolean }): Promise<ChecklistFileAttachment[]> {
  return fetchEntityAttachments(ENTITY_TYPE, parentId, opts);
}

export function deleteChecklistAttachment(attachmentId: string, userId: string | undefined): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}
